<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationPublicTermCondForm :info="info" :businessId="businessId"  />
      
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalRegisterForm from "../components/e-registration-professional-register/ERegistrationProfessionalRegisterForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo";
import ERegistrationPublicTermCondForm from "../components/ERegistrationPublicTermCondForm";

export default {
  props: ["info", "businessId"],
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationPublicTermCondForm,
    ERegistrationProfessionalRegisterForm
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.info) {
      next({ name: "ERegistrationProfessionalActivate" });
    } else {
      next();
    }
  },
  data() {
    return {
      accepted: false,
      errors: [],
      errorMsg: "",
    };
  },
};
</script>

<style lang="scss" scoped></style>
